import { getGLEntity } from "../../../../../actions/Utilities/GLEntity";
import { useQuery } from "react-query";

export default function useGLEntity() {
  //Fetching GLEntity Details
  const { data, isFetching } = useQuery("GetGLEntitys", getGLEntity, {
    refetchOnWindowFocus: false,
  });
  return { data, isFetching };
}
